import { SoftwareType } from './types';
import { SoftwareTypes } from './runtimeTypes';

export const assertValidSoftwareType = (candidate: SoftwareType) => {
    if (SoftwareTypes.indexOf(candidate) < 0) {
        throw new Error(`Expected valid software type but received "${candidate}".`);
    }
};
